module.exports = __webpack_public_path__ + "static/media/808-kick-01.33b2abc7.wav";